import Vue from 'vue';
import VueI18n from 'vue-i18n';

Vue.use(VueI18n);

export const getBrowserLocale = () => {
	const lang = (navigator.language || 'ca').split('-')[0].toLowerCase(),
		supported = ['ca', 'es', 'en'];
	return supported.includes(lang) ? lang : 'ca';
};

/* eslint-disable-next-line one-var */
export const i18n = new VueI18n({
	locale: getBrowserLocale(),
	fallbackLocale: 'en',
	messages: {
		ca: {
			all_documents_links_in_series_overwritten: 'Tots els enllaços que es trobin a les sèries es sobreescriuran',
			back_to_general: 'Veure tots els productes',
			cancel: 'Cancel·lar',
			// click_to_give_application_feedback: 'Feu clic per a deixar un comentari sobre l\'aplicació',
			// click_to_give_version_feedback: 'Feu clic per a deixar un comentari sobre aquesta versió del producte',
			category: 'Categoria',
			certification: 'Certificat',
			checkAll: 'Seleccionar-les totes',
			checkUpdates: 'Comprovar actualitzacions',
			checkUpdatesTitle: 'Comprovar actualitzacions de la documentació des de la seva darrera visita (7 dies mínim)',
			click_to_add_comment: 'Feu click per afegir o editar comentari',
			click_to_add_favorite: 'Feu click per marcar o desmarcar el document com a favorit',
			click_to_add_item: 'Feu clic per afegir un nou ítem a la versió del producte',
			click_to_filter_documents: 'Feu clic per obrir els criteris de filtratge de documents',
			click_to_see_version_document_item: 'Feu clic per veure l\'històric del document',
			click_to_select_document_to_download: 'Feu clic per seleccionar aquest document per descarregar',
			click_to_select_documents_to_download: 'Feu clic per seleccionar els documents per descarregar',
			click_to_sort_items_by_this_field: 'Feu clic per a ordenar la llista alfabèticament per aquest camp',
			click_to_unselect_document_to_download: 'Feu clic per deseleccionar els documents per descarregar',
			close: 'Tancar',
			country: 'País',
			copy_to_clipboard: 'Feu clic per a copiar la ruta del document al porta-retalls',
			could_not_check_document_info: 'Error de comunicació amb el servidor',
			current_series_and_version: 'Aquesta es la sèrie i versió actual on esteu afegint el document',
			date_editor: 'Data / Editor',
			defaultFiltersPackages: 'Paquets predefinits',
			description: 'Descripció',
			description_as_title: 'Títol',
			description_not_available: 'Descripció no disponible',
			discontinued_products: 'Sèries descatalogades',
			display_discontinued_products: 'Mostrar sèries descatalogades',
			display_family: 'Mostrar família',
			document_already_included_in_series: 'Aquest document ja es troba inclòs en aquesta sèrie i versió',
			document_link_favorite_in_other_series: 'Heu marcat aquest document com a favorit en una altre serie',
			document_link_favorite_in_this_series: 'Heu marcat aquest document com a favorit',
			document_name: 'Nom del document',
			document_not_found: 'El document no existeix',
			document_size: 'Mida',
			documents_filtered_by_category_subcategory: 'Els documents estan filtrats per categoria i/o subcategoria',
			documents_filtered_by_language: 'Els documents estan filtrats per idioma',
			documents_links_filters: 'Filtres d\'enllaços de documentació',
			download: 'Descarregar',
			download_documents_instructions: 'Seleccioneu els documents que voleu i feu clic a \'Descarregar\'. Després rebreu un primer correu electrònic que confirmarà que s\'estan preparanti, quan els documents estiguin a punt, en rebreu un altre amb l\'enllaç que us portarà als documents, junt amb instruccions per descarregar-los.',
			duplicate_title: 'Aquest document ja existeix',
			edit_item: 'Editar aquest element',
			error_preaparing_documentation: 'Error preparant la documentació',
			error_saving_data: 'S\'ha produït un error desant les dades',
			family_not_selected: 'Aquesta família no està seleccionada.',
			hide_discontinued_products: 'Amagar productes discontinuats',
			hide_family: 'Amagar aquesta família',
			go_to_stream_videos: 'Veure els vídeos a Stream',
			hideCategory: 'Amagar aquesta categoria',
			hideSubcategory: 'Amagar aquesta subcategoria',
			include_document_in_pendrive: 'Incloure al Pendrive de documentació',
			insert_comment: 'Si voleu deixar algunes notes sobre aquest document, podeu fer-ho aquí. Aquestes notes seran privades i ningú més les podrà veure.',
			internal_document: 'Aquest document es només per ús intern, no distribuir',
			item_included_in_pendrive: 'Aquest element s\'inclou al Pendrive de documentació dels equips',
			item_included_in_pendrive_not_series: 'Aquest element està marcat per incloure\'s en el Pendrive de documentació dels equips, però la sèrie no',
			language: 'Idioma',
			loading: 'Carregant...',
			loading_initial_data: 'Carregant les dades per a iniciar l\'aplicació.',
			access_denied: 'Accés denegat',
			access_denied_message: 'No teniu permisos per accedir a aquesta aplicació.',
			modal_add_document_link_title: 'Afegir enllaç de documentació',
			modal_download_document_title: 'Seleccionar documents a descarregar',
			modal_edit_document_link_title: 'Editar enllaç de documentació',
			modal_edit_user_note_comment_title: 'Afegir/Editar notes',
			modal_show_release_notes_title: 'Novetats de la versió',
			modal_show_versions_document_link_title: 'Versions del document',
			modified: 'Modificat',
			next: 'Següent',
			no_series_match_current_filters: 'No hi ha cap sèrie a mostrar per a aquesta família amb els filtres actuals.',
			nothing_to_see_documentation_links: 'No hi ha enllaços de documentació per a aquesta versió (encara)',
			ok: 'D\'acord',
			openDocument: 'Feu clic per obrir document',
			other_documents: 'Altres documents',
			previous: 'Anterior',
			product_version_hi_res_pictures: 'Imatges en alta resolució',
			product_version_lo_res_pictures: 'Imatges en baixa resolució',
			product_version_slideshow: 'Passador d\'imatges',
			release_notes_manual: 'Per a més informació reviseu el ',
			save: 'Desar',
			search_and_modify_all_versions: 'Buscar i mofidicar el document a totes les sèries i versions',
			series_has_videos_in_stream: 'Hi ha vídeos d\'aquesta sèrie a Stream',
			series_included_in_pendrive: 'Aquesta sèrie s\'inclou al Pendrive de documentació dels equips',
			series_version_to_modify: 'Sèries i versions on es modificarà el document',
			series_versions_selected: 'Sèries i versions seleccionades',
			showAllLanguages: 'Mostrar documents en qualsevol idioma (inclosos els no especificats)',
			showByLanguages: 'Mostrar només documents en aquests idiomes (n\'heu de seleccionar almenys un)',
			showingFeatureList: 'Des de l\'última visita hem implementat algunes millores a l\'aplicació. Aquí en teniu un resum.',
			showingListFiltered: 'Es mostren {number} de {total} documents',
			showingListNoFiltered: 'Es mostren tots els documents ({number})',
			subcategory: 'Subcategoria',
			title: 'Títol',
			title_as_name: 'Nom',
			uncheckAll: 'Deseleccionar-les totes',
			updated: 'Actualitzat',
			usage_app_view: 'Visualització d\'ús de l\'aplicació',
			userManual: 'Manual de l\'usuari',
			version: 'Versió',
			version_comment: 'Descripció / Comentaris de la versió',
			versions: 'Versions',
			wrong_title_format: 'Format del nom del document incorrecte',

			AR: 'Àrab',
			CA: 'Català',
			CS: 'Txec',
			DE: 'Alemany',
			EN: 'Anglès',
			ES: 'Espanyol',
			FI: 'Finès',
			FR: 'Francès',
			HU: 'Hongarès',
			IT: 'Italià',
			PL: 'Polonès',
			PT: 'Portugès',
			RU: 'Rus',
			TR: 'Turc',
			ZH: 'Xinès',

			releaseNotes_addEditLinkFeatureText_0: 'Si sou editor/a de documentació, ja podeu entrar els enllaços directament des de l\'aplicació.',
			releaseNotes_addEditLinkFeatureTitle: 'Edició d\'enllaços',

			releaseNotes_documentPackagesFeatureText_0: 'A l\'hora d\'enviar documents a algun client/proveïdor, ja no cal que els descarregueu i envieu per correu electrònic. Ara ho podeu fer seleccionant quins documents voleu empaquetar. L\'aplicació us els copiarà a una carpeta i us enviarà un correu amb un enllaç que podreu reenviar a qui us calgui. (L\'enllaç és anònim i caduca als 10 dies.)',
			releaseNotes_documentPackagesFeatureTitle: 'Paquets de descàrrega',

			releaseNotes_generalViewFiltersFeatureText_0: 'Podeu mostrar les sèries segons la família a què pertanyen o si estan en catàleg / descatalogades. La selecció quedarà desada al navegador per a futures visites.',
			releaseNotes_generalViewFiltersFeatureTitle: 'Filtre per família',

			releaseNotes_productViewFiltersFeatureText_0: 'Dins d\'una sèrie, fent clic a la icona del filtre (embut) de la part superior dreta podreu seleccionar quines categories, subcategories i idiomes de documents es mostren. També podreu triar paquets de documentació predefinits.',
			releaseNotes_productViewFiltersFeatureTitle: 'Filtre per categoria i idioma',

			releaseNotes_searchForUpdatesFeatureText_0: 'També podeu comprovar, família a família, la documentació de quines sèries s\'ha actualitzat des de la vostra última visita (o durant els últims set dies, si utilitzeu sovint l\'aplicació).',
			releaseNotes_searchForUpdatesFeatureTitle: 'Comprovar actualitzacions',

			releaseNotes_versionHistoryFeatureText_0: 'Les dates i les descripcions que apareixen al costat dels documents corresponen a les de publicació del document. A més, si necessiteu una versió anterior d\'un document, hi podeu accedir des de la finestra d\'historial de versions integrada.',
			releaseNotes_versionHistoryFeatureTitle: 'Dates, descripcions i versions de documents millorades',
			login_selection_title: 'Com voleu accedir?',
			login_o365: 'Office 365 (Salicru)',
			login_user: 'Usuari Extern',
			email: 'Correu electrònic',
			password: 'Contrasenya',
			login: 'Inicia sessió',
			back: 'Torna',
			login_error: 'Error en l\'inici de sessió. Comproveu les credencials.',
			copyright_reserved: 'Tots els drets reservats.',
		},
		es: {
			all_documents_links_in_series_overwritten: 'Todos los enlaces que se encuentren en las series serán sobreescritos',
			back_to_general: 'Ver todos los productos',
			cancel: 'Cancelar',
			category: 'Categoria',
			certification: 'Certificado',
			checkAll: 'Seleccionarlas todas',
			checkUpdates: 'Comprobar actualizaciones',
			checkUpdatesTitle: 'Comprobar actualizaciones de la documentación desde su última visita (7 dias mínimo)',
			click_to_add_comment: 'Haga click para añadir o editar comentario',
			click_to_add_favorite: 'Haga click para marcar o desmarcar el documento como favorito',
			click_to_add_item: 'Haga click para añadir un item a la versión del producto',
			click_to_filter_documents: 'Haga click para abrir los criterios de filtraje de documentos',
			click_to_give_application_feedback: 'Haga click para dejar un comentario sobre la aplicación',
			click_to_give_version_feedback: 'Haga click para dejar un comentario sobre esta versión del producto',
			click_to_see_version_document_item: 'Haga click para ver el histórico del documento',
			click_to_select_document_to_download: 'Haga clic para seleccionar este documento para descargar',
			click_to_select_documents_to_download: 'Haga clic para seleccionar los documentos para descargar',
			click_to_sort_items_by_this_field: 'Haga click para ordenar la lista alfabéticamente por este campo',
			click_to_unselect_document_to_download: 'Haga clic para deseleccionar este documento para descargar',
			close: 'Cerrar',
			country: 'País',
			copy_to_clipboard: 'Haga click para copiar la ruta del documento al portapapeles',
			could_not_check_document_info: 'Error de comunicación con el servidor',
			current_series_and_version: 'Esta es la series y versión actual donde estais añadiendo el documento',
			date_editor: 'Fecha / Editor',
			defaultFiltersPackages: 'Paquetes predefinidos',
			description: 'Descripción',
			description_as_title: 'Titulo',
			description_not_available: 'Descripción no disponible',
			discontinued_products: 'Series descatalogadas',
			display_discontinued_products: 'Mostrar series descatalogadas',
			display_family: 'Mostrar familia',
			document_already_included_in_series: 'Este documento ya se encuentra incluido en esta serie y versión',
			document_link_favorite_in_other_series: 'Ha marcado este documento como favorit en otra serie',
			document_link_favorite_in_this_series: 'Ha marcado este documento como favorit',
			documents: 'documentos',
			documents_filtered_by_category_subcategory: 'Los documentos estan filtrados por categoria y/o subcategoria',
			documents_filtered_by_language: 'Los documentos estan filtrados por idioma',
			documents_links_filters: 'Filtros de enlaces de documentación',
			document_name: 'Nombre del documento',
			document_not_found: 'El documento no existe',
			document_size: 'Tamaño',
			download: 'Descargar',
			download_documents_instructions: 'Seleccione los documentos que desea y haga clic en \'Descargar\'. Después recibirá un primer correo electrónico que confirmará que se están preparando y, cuando los documentos estén listos, recibirá otro con el enlace que le llevará a los documentos, junto con instrucciones para descargarlos.',
			duplicate_title: 'El documento ya existe',
			edit_item: 'Editar este elemento',
			error_preaparing_documentation: 'Error preparando documentación',
			error_saving_data: 'Se ha producido un error guardando los datos',
			family_not_selected: 'Esta familia no está seleccionada.',
			filter: 'Filtro',
			hide_discontinued_products: 'Esconder productos discontinuados',
			hide_family: 'Esconder esta familia',
			go_to_stream_videos: 'Ver los vídeos en Stream',
			hideCategory: 'Esconder esta categoria',
			hideSubcategory: 'Esconder esta subcategoria',
			include_document_in_pendrive: 'Incluir en el Pendrive de documentación',
			insert_comment: 'Si quiere dejar algunas notas sobre este documento, puede hacerlo aquí. Estas notas serán privadas y nadie más las podrá ver.',
			internal_document: 'Este documento es solo para uso interno, no distribuir',
			item_included_in_pendrive: 'Este elemento se incluye en el Pendrive de documentación de los equipos',
			item_included_in_pendrive_not_series: 'Este elemento está marcado para incluirse en el Pendrive de documentación de los equipos, pero la serie no',
			language: 'Idioma',
			loading: 'Cargando...',
			loading_initial_data: 'Cargando los datos para iniciar la aplicación.',
			access_denied: 'Acceso denegado',
			access_denied_message: 'No tienes permisos para acceder a esta aplicación.',
			modal_add_document_link_title: 'Añadir enlace de documentación',
			modal_download_document_title: 'Seleccionar documentos a descargar',
			modal_edit_document_link_title: 'Editar enlace de documentación',
			modal_edit_user_note_comment_title: 'Añadir/Editar notas',
			modal_show_release_notes_title: 'Novedades de la version',
			modal_show_versions_document_link_title: 'Versiones del documento',
			modified: 'Modificado',
			next: 'Siguiente',
			no_series_match_current_filters: 'No hay ninguna serie a mostrar para esta familia con los filtros actuales.',
			nothing_to_see_documentation_links: 'No hay enlaces de documentación para esta versión (aún)',
			ok: 'Aceptar',
			openDocument: 'Haga click para abrir documento',
			other_documents: 'Otros documentos',
			previous: 'Anterior',
			product_version_hi_res_pictures: 'Imágenes en alta resolución',
			product_version_lo_res_pictures: 'Imágenes en baja resolución',
			product_version_slideshow: 'Pasador de imágenes',
			release_notes_manual: 'Para más información revise el ',
			save: 'Guardar',
			search_and_modify_all_versions: 'Buscar y mofidicar el documento en todas les series y versiones',
			series_has_videos_in_stream: 'Hay vídeos de esta serie en Stream',
			series_included_in_pendrive: 'Esta serie se incluye en el Pendrive de documentación de los equipos',
			series_version_to_modify: 'Series y versiones donde se modificará el documento',
			series_versions_selected: 'Series y versiones seleccionadas',
			showAllLanguages: 'Mostrar documentos en cualquier idioma (incluidos los no especificados)',
			showByLanguages: 'Mostrar solo documentos en estos idiomas (se ha de seleccionar al menos unos)',
			showingFeatureList: 'Desde su última visita hemos implementado algunas mejoras en la aplicación. Aquí tiene un resumen de ellas.',
			showingListNoFiltered: 'Se muestran todos los documentos ({number})',
			subcategory: 'Subcategoria',
			title: 'Titulo',
			title_as_name: 'Nombre',
			uncheckAll: 'Deseleccionarlas todas',
			updated: 'Actualizado',
			usage_app_view: 'Visualización de uso de la aplicación',
			userManual: 'Manual del usuario',
			version: 'Versión',
			version_comment: 'Descripción / Comentarios de la versión',
			versions: 'Versiones',
			wrong_title_format: 'Formato del nombre del documento incorrecto',

			AR: 'Árabe',
			CA: 'Catalán',
			CS: 'Checo',
			DE: 'Alemán',
			EN: 'Inglés',
			ES: 'Español',
			FI: 'Finés',
			FR: 'Francés',
			HU: 'Hungaro',
			IT: 'Italiano',
			PL: 'Polaco',
			PT: 'Portugés',
			RU: 'Ruso',
			TR: 'Turco',
			ZH: 'Chino',

			releaseNotes_addEditLinkFeatureText_0: 'Si es editor/a de documentación, ya puede entrar los enlaces directamente desde la aplicación.',
			releaseNotes_addEditLinkFeatureTitle: 'Edición de enlaces',

			releaseNotes_documentPackagesFeatureText_0: 'A la hora de enviar documentos a algún cliente/proveedor, ya no es necesario que los descargue y envíe por correo electrónico. Ahora puede hacerlo seleccionando qué documentos quiere empaquetar. La aplicación se los copiará a una carpeta y le enviará un correo con un vínculo que podrá reenviar a quien necesite. (El enlace es anónimo y caduca a los 10 días.)',
			releaseNotes_documentPackagesFeatureTitle: 'Paquetes de descarga',

			releaseNotes_generalViewFiltersFeatureText_0: 'Puede mostrar las series según la familia a la que pertenecen o si están en catálogo/descatalogadas. La selección quedará guardada en el navegador para futuras visitas.',
			releaseNotes_generalViewFiltersFeatureTitle: 'Filtro por familia',

			releaseNotes_productViewFiltersFeatureText_0: 'Dentro de una serie, haciendo clic en el icono del filtro (embudo) de la parte superior derecha podrá seleccionar qué categorías, subcategorías e idiomas de documentos se muestran. También podrá elegir paquetes de documentación predefinidos.',
			releaseNotes_productViewFiltersFeatureTitle: 'Filtro por categoría e idioma',

			releaseNotes_searchForUpdatesFeatureText_0: 'También puede comprobar, familia a familia, la documentación de qué series se ha actualizado desde su última visita (o durante los últimos 7 días, si usa la aplicación a menudo).',
			releaseNotes_searchForUpdatesFeatureTitle: 'Comprobar actualizaciones',

			releaseNotes_versionHistoryFeatureText_0: 'Las fechas y descripciones que aparecen junto a los documentos corresponden a las de publicación del documento. Además, si necesita una versión anterior de un documento, puede acceder a ella desde la ventana de historial de versiones integrada.',
			releaseNotes_versionHistoryFeatureTitle: 'Fechas, descripciones y versiones de documentos mejoradas',
			login_selection_title: '¿Cómo desea acceder?',
			login_o365: 'Office 365 (Salicru)',
			login_user: 'Usuario Externo',
			email: 'Correo electrónico',
			password: 'Contraseña',
			login: 'Iniciar sesión',
			back: 'Volver',
			login_error: 'Error en el inicio de sesión. Compruebe las credenciales.',
			copyright_reserved: 'Todos los derechos reservados.',

		},
		en: {
			all_documents_links_in_series_overwritten: 'All links found in the series will be overwritten.',
			back_to_general: 'See all products',
			cancel: 'Cancel',
			category: 'Category',
			certification: 'Certification',
			checkAll: 'Select all',
			checkUpdates: 'Check updates',
			checkUpdatesTitle: 'Check for updated documentation since your last visit (7 days minimum)',
			click_to_add_comment: 'Click to add or edit comment',
			click_to_add_favorite: 'Click to mark or unmark document as favorite',
			click_to_add_item: 'Click to add item to this product version',
			click_to_filter_documents: 'Click to open the document filtering criteria window',
			click_to_give_application_feedback: 'Click to leave a comment about this app',
			click_to_give_version_feedback: 'Click to leave a comment about this product version',
			click_to_see_version_document_item: 'Click to see the document history',
			click_to_select_document_to_download: 'Click to select this document to download',
			click_to_select_documents_to_download: 'Click to select the documents to download',
			click_to_sort_items_by_this_field: 'Click to sort list alphabetically by this field',
			click_to_unselect_document_to_download: 'Click to unselect the documents to download',
			close: 'Close',
			country: 'Country',
			copy_to_clipboard: 'Click to copy the document\'s path to clipboard',
			could_not_check_document_info: 'Communication with server failed',
			current_series_and_version: 'This is the current series and version where you are adding the document',
			date_editor: 'Date / Editor',
			defaultFiltersPackages: 'Default packages',
			description: 'Description',
			description_as_title: 'Title',
			description_not_available: 'Description not available',
			discontinued_products: 'Discontinued series',
			display_discontinued_products: 'Show discontinued series',
			display_family: 'Display family',
			document_already_included_in_series: 'Document is already included in this series and version',
			document_link_favorite_in_other_series: 'has marked this document as a favorite in other series',
			document_link_favorite_in_this_series: 'Has marked this document as a favorite',
			document_name: 'Document name',
			document_not_found: 'Document does not exist',
			documents_filtered_by_category_subcategory: 'Documents are filtered by category and/or subcategory',
			documents_filtered_by_language: 'Documents are filtered by language',
			documents_links_filters: 'Document links filters',
			document_size: 'Size',
			download: 'Download',
			download_documents_instructions: 'Select the documents you want and click \'Download\'. You will then receive a first email confirming that they are being prepared and, once the documents are ready, you will receive another one with the link to the documents, along with instructions for downloading them.',
			duplicate_title: 'Document already exists',
			edit_item: 'Edit this item',
			error_preaparing_documentation: 'Error preparing documentation',
			error_saving_data: 'Error saving data',
			family_not_selected: 'This family is not selected.',
			filter: 'Filter',
			hide_discontinued_products: 'Hide discontinued products',
			hide_family: 'Hide this family',
			go_to_stream_videos: 'See videos in Stream',
			hideCategory: 'Hide this category',
			hideSubcategory: 'Hide this subcategory',
			include_document_in_pendrive: 'Include in the documentation\'s Pendrive',
			insert_comment: 'Should you want to leave some notes regarding this document, you can do it here. These notes will be private and no other user will be able to see them.',
			internal_document: 'This document is only for internal use, do not distribute',
			item_included_in_pendrive: 'This element is included in series documentation Pendrive',
			item_included_in_pendrive_not_series: 'This element is marked to be included in series documentation Pendrive, but series is not',
			language: 'Language',
			loading: 'Loading...',
			loading_initial_data: 'Loading data to start the application.',
			access_denied: 'Access denied',
			access_denied_message: 'You do not have permission to access this application.',
			modal_add_document_link_title: 'Edit document link',
			modal_download_document_title: 'Select documents to download',
			modal_edit_document_link_title: 'Edit document link',
			modal_edit_user_note_comment_title: 'Add/Edit notes',
			modal_show_release_notes_title: 'Version news',
			modal_show_versions_document_link_title: 'Document versions',
			modified: 'Modified',
			next: 'Next',
			no_series_match_current_filters: 'There are no series to display for this family with the current filters.',
			nothing_to_see_documentation_links: 'There are no documentation links for this version (yet)',
			ok: 'OK',
			openDocument: 'Click to open document',
			other_documents: 'Other documents',
			previous: 'Previous',
			product_version_hi_res_pictures: 'High Resolution Pictures',
			product_version_lo_res_pictures: 'Low Resolution Pictures',
			product_version_slideshow: 'Slideshow Pictures',
			release_notes_manual: 'For more information review the ',
			save: 'Save',
			search_and_modify_all_versions: 'Search and modify the document in all series and versions',
			series_has_videos_in_stream: 'There ara videos of this series in Stream',
			series_included_in_pendrive: 'This series is included in series documentation Pendrive',
			series_version_to_modify: 'Series and versions where document will be modified',
			series_versions_selected: 'Series and versions selected',
			showAllLanguages: 'Show documents in any language (including not specified ones)',
			showByLanguages: 'Show only documents in these languages (select at least one)',
			showingFeatureList: 'Since your last visit we have implemented some improvements to the application. Here\'s a brief summary of them.',
			showingListFiltered: 'Showing {number} of {total} documents',
			showingListNoFiltered: 'Showing all documents ({number})',
			subcategory: 'Subcategory',
			title: 'Title',
			title_as_name: 'Name',
			uncheckAll: 'Unselect all',
			updated: 'Updated',
			usage_app_view: 'Visualization of application usage',
			userManual: 'User manual',
			version: 'Version',
			version_comment: 'Description / Version comments',
			versions: 'Versions',
			wrong_title_format: 'Wrong document name format',

			AR: 'Arabic',
			CA: 'Catalan',
			CS: 'Czech',
			DE: 'German',
			EN: 'English',
			ES: 'Spanish',
			FI: 'Finnish',
			FR: 'French',
			HU: 'Hungarian',
			IT: 'Italian',
			PL: 'Polish',
			PT: 'Portuguese',
			RU: 'Russian',
			TR: 'Turkish',
			ZH: 'Chinese',

			releaseNotes_addEditLinkFeatureText_0: 'If you are a documentation publisher, you can enter the links directly from the application.',
			releaseNotes_addEditLinkFeatureTitle: 'Editing links',

			releaseNotes_documentPackagesFeatureText_0: 'When sending documents to a customer / supplier, you no longer need to download and email them. You can now do this by selecting which documents you want to pack. The application will copy them to a folder and send you an email with a link that you can forward to whoever you need. (The link is anonymous and expires in 10 days.)',
			releaseNotes_documentPackagesFeatureTitle: 'Download packages',

			releaseNotes_generalViewFiltersFeatureText_0: 'You can show the series according to the family they belong to or if they are in the catalog / discontinued. The selection will be saved in the browser for future visits.',
			releaseNotes_generalViewFiltersFeatureTitle: 'Family filter',

			releaseNotes_productViewFiltersFeatureText_0: 'Within a series, you can select which categories, subcategories, and document languages are displayed by clicking on the filter icon (funnel) at the top right. You can also choose predefined documentation packages.',
			releaseNotes_productViewFiltersFeatureTitle: 'Filter by category and language',

			releaseNotes_searchForUpdatesFeatureText_0: 'You can also check, family by family, for which series\'s documentation have been updated since your last visit (or during the last 7 days, if you\'re a frequent user).',
			releaseNotes_searchForUpdatesFeatureTitle: 'Check updates',

			releaseNotes_versionHistoryFeatureText_0: 'The dates and descriptions that appear next to the documents correspond to the date of publication of the document. Also, if you need an earlier version of a document, you can access it from the built-in version history window.',
			releaseNotes_versionHistoryFeatureTitle: 'Improved dates, descriptions and document versions',
			login_selection_title: 'How do you want to access?',
			login_o365: 'Office 365 (Salicru)',
			login_user: 'External User',
			email: 'Email',
			password: 'Password',
			login: 'Login',
			back: 'Back',
			login_error: 'Login error. Please check your credentials.',
			copyright_reserved: 'All rights reserved.',

		},
	},
});
